<ng-container *ngIf="viewSelectedFilters" >
  <div class="selection-filter-cont" [ngStyle]="styles" [class.in-filter-bar]="inFilterBar" [class.desktop]="!isMobile">
    <div class="wrapper" [class.sticky]="sticky">
      <div class="external-filter">
        <ng-content select="[selectedFilters]"></ng-content>
      </div>
    </div>
  </div>
</ng-container>

